export default "__VITE_ASSET__CArugfbL__";